<template>
  <el-row v-loading="loading">
    <el-row class="margin-top-25">
      <el-form>
        <el-col v-for="(item, $index) in ProxyManagerConfig" :key="$index">
          <el-form-item :label="item.Description">
            <el-input-number v-model="item.Value" size="mini"/>
            <p class="p-info-desc">{{ item.Info }}</p>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
  </el-row>
</template>


<script>

import ProxyManagerService from "@/services/ProxyManagerService";

export default {
  name: "ProxyManagerConfig",
  props: ['idCia'],
  data() {
    return {
      loading: false,
      ProxyManagerConfig: []
    };
  },
  created() {
    this.Listar();
  },
  mounted() {
  },
  methods: {
    Listar() {
      if (!this.proxyManagerService)
        this.proxyManagerService = new ProxyManagerService(this)
      this.proxyManagerService.ListarProxyManagerConfig(this.callback)
    },
    callback(res) {
      this.ProxyManagerConfig = res.Data
    },
    Gravar() {
      this.proxyManagerService.GravarProxyManagerConfig(this.ProxyManagerConfig, this.callbackGravar, this.callbackErro)
    },
    callbackGravar(res) {
      if(!res.Success)
        this.callbackErro()
    },
    callbackErro() {
      this.$message.error('Erro ao gravar dados do Proxy Manager')
    }
  },
  computed: {}
};
</script>

<style scoped>
.p-info-desc {
  font-size: 12px;
  color: #909399;
  margin-bottom: 0px;
}
</style>
